import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Eye, Flame, AlertTriangle, XCircle, CheckCircle, Clock, ShieldAlert, Dna, Zap, HelpCircle, AlertOctagon } from 'lucide-react';
export function NewProblemSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref2, inView2] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref3, inView3] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref4, inView4] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref5, inView5] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref6, inView6] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref7, inView7] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref8, inView8] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref9, inView9] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref10, inView10] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref11, inView11] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref12, inView12] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref13, inView13] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref14, inView14] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref15, inView15] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  return <section className="relative pt-8 sm:pt-12 pb-8 sm:pb-12 px-4 sm:px-6 bg-black" data-id="element-2137">
      {/* DRAMATIC VAULT TRANSFORMATION - Bold and unmistakable */}

      {/* Deep vault background - much darker than hero */}
      <div className="absolute inset-0 bg-gradient-to-b from-zinc-950 via-neutral-950 to-black" data-id="element-2138" />

      {/* Heavy concrete texture - very visible */}
      <div className="absolute inset-0 opacity-20" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='400' height='400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' /%3E%3C/filter%3E%3Crect width='400' height='400' filter='url(%23noise)' opacity='0.7'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'repeat'
    }} data-id="element-2139" />

      {/* BOLD security grid - clearly visible */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `
            linear-gradient(rgba(217, 119, 6, 0.6) 2px, transparent 2px),
            linear-gradient(90deg, rgba(217, 119, 6, 0.6) 2px, transparent 2px)
          `,
      backgroundSize: '80px 80px'
    }} data-id="element-2140" />

      {/* MASSIVE vault door frame - unmistakable borders */}
      <div className="absolute left-0 inset-y-0 w-8 bg-gradient-to-r from-stone-700 via-stone-800 to-transparent hidden lg:block" data-id="element-2141" />
      <div className="absolute right-0 inset-y-0 w-8 bg-gradient-to-l from-stone-700 via-stone-800 to-transparent hidden lg:block" data-id="element-2142" />

      {/* TOP SECRET corner stamps - bold and visible */}
      <div className="absolute top-12 left-12 hidden lg:block" data-id="element-2143">
        <div className="relative w-32 h-32 border-4 border-amber-600/60 rotate-12 flex items-center justify-center" data-id="element-2144">
          <div className="absolute inset-0 bg-amber-600/10" data-id="element-2145" />
          <span className="text-amber-500 font-bold text-xs tracking-widest rotate-[-12deg]" data-id="element-2146">
            CLASSIFIED
          </span>
        </div>
      </div>
      <div className="absolute top-12 right-12 hidden lg:block" data-id="element-2147">
        <div className="relative w-32 h-32 border-4 border-red-600/60 rotate-[-12deg] flex items-center justify-center" data-id="element-2148">
          <div className="absolute inset-0 bg-red-600/10" data-id="element-2149" />
          <span className="text-red-500 font-bold text-xs tracking-widest rotate-12" data-id="element-2150">
            RESTRICTED
          </span>
        </div>
      </div>

      {/* Heavy vault door bolts on sides */}
      <div className="absolute left-2 sm:left-4 top-1/4 hidden lg:flex flex-col gap-16" data-id="element-2151">
        {[...Array(3)].map((_, i) => <div key={i} className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-br from-stone-600 to-stone-800 border-2 border-amber-700/40 shadow-lg" data-id="element-2152">
            <div className="w-full h-full rounded-full bg-gradient-to-br from-stone-700 to-stone-900 m-0.5" data-id="element-2153" />
          </div>)}
      </div>
      <div className="absolute right-2 sm:right-4 top-1/4 hidden lg:flex flex-col gap-16" data-id="element-2154">
        {[...Array(3)].map((_, i) => <div key={i} className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-br from-stone-600 to-stone-800 border-2 border-amber-700/40 shadow-lg" data-id="element-2155">
            <div className="w-full h-full rounded-full bg-gradient-to-br from-stone-700 to-stone-900 m-0.5" data-id="element-2156" />
          </div>)}
      </div>

      {/* STRONG vignette - vault entrance */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_0%,_rgba(0,0,0,0.4)_70%,_rgba(0,0,0,0.8)_100%)] pointer-events-none" data-id="element-2157" />

      {/* Dark top shadow - descending into vault */}
      <div className="absolute top-0 inset-x-0 h-32 sm:h-48 bg-gradient-to-b from-black via-black/60 to-transparent pointer-events-none" data-id="element-2158" />

      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 20
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto" data-id="element-2159">
        {/* Header */}
        <div className="flex items-center justify-center gap-4 mb-6 sm:mb-8" data-id="element-2160">
          <div className="w-16 sm:w-24 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-transparent" data-id="element-2161" />
          <Eye className="w-6 h-6 sm:w-8 sm:h-8 text-amber-500" data-id="element-2162" />
          <div className="w-16 sm:w-24 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-transparent" data-id="element-2163" />
        </div>

        <h2 className="text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-serif mb-8 sm:mb-12 text-center text-stone-100 leading-tight" style={{
        fontFamily: 'Cinzel, serif',
        textShadow: '0 0 40px rgba(217, 119, 6, 0.3)'
      }} data-id="element-2164">
          The Future Is Becoming{' '}
          <span className="inline-block bg-gradient-to-r from-stone-100 via-orange-400 to-red-500 bg-clip-text text-transparent font-bold" style={{
          textShadow: '0 0 30px rgba(249, 115, 22, 0.5)'
        }} data-id="element-2165">
            Increasingly
          </span>{' '}
          <span className="inline-block text-red-500 font-extrabold" style={{
          textShadow: '0 0 60px rgba(220, 38, 38, 0.8), 0 0 100px rgba(220, 38, 38, 0.4)'
        }} data-id="element-2166">
            Fake
          </span>
        </h2>

        <div className="space-y-6 sm:space-y-8 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-2167">
          <p className="text-stone-100 text-center text-lg sm:text-xl" data-id="element-2168">
            And Your Biology Is Paying The Price
          </p>

          <p className="text-xl md:text-2xl font-bold text-stone-100" data-id="element-2169">
            Here's what's happening right now while you read this:
          </p>

          {/* AI Hallucinations */}
          <div className="space-y-3 sm:space-y-4" data-id="element-2170">
            <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-2171">
              AI chatbots are confidently hallucinating garbage health advice
              that is being spread and used as material by... More AI chatbots.
            </p>
            <p className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 text-base sm:text-lg" data-id="element-2172">
              One wrong Reddit post gets cited by a blogger, quoted by a
              YouTuber, summarized by ChatGPT, and trusted by thousands who
              think they're getting the truth.
            </p>
          </div>

          {/* Influencers */}
          <div className="space-y-3 sm:space-y-4" data-id="element-2173">
            <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-2174">
              Influencers are optimizing for views and engagement, not accuracy
              and outcomes.
            </p>
            <p className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 text-base sm:text-lg" data-id="element-2175">
              They're teaching peptide "stacks" they don't understand because
              the algorithm rewards confident simplicity over nuanced precision.
            </p>
          </div>

          {/* Doctors */}
          <div className="space-y-3 sm:space-y-4" data-id="element-2176">
            <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-2177">
              Even qualified doctors are operating with fragments of knowledge,
              regurgitating what they heard from someone who heard it from
              someone else.
            </p>
            <p className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 italic text-stone-400 text-base sm:text-lg" data-id="element-2178">
              A broken telephone game with your biology as the stakes.
            </p>
          </div>

          {/* Getting worse */}
          <div className="space-y-3 sm:space-y-4 mt-8 sm:mt-12" data-id="element-2179">
            <p className="text-xl md:text-2xl font-bold text-stone-100" data-id="element-2180">
              But it's getting WORSE.
            </p>
            <p className="text-2xl md:text-3xl font-bold text-amber-500" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.3)'
          }} data-id="element-2181">
              Way worse.
            </p>
          </div>

          <p className="text-lg md:text-xl text-stone-100" data-id="element-2182">
            And if you don't have a trusted source of REAL intelligence...
          </p>

          <p className="text-2xl md:text-3xl font-bold text-center text-amber-500" style={{
          textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
        }} data-id="element-2183">
            You're gonna get buried.
          </p>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 mt-10 sm:mt-16" data-id="element-2184">
            <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2185" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-2186" />
            <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2187" />
          </div>

          {/* Section 2: Butterfly Effect */}
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-stone-100 mt-10 sm:mt-16 mb-8 sm:mb-12" style={{
          fontFamily: 'Cinzel, serif',
          textShadow: '0 0 30px rgba(217, 119, 6, 0.2)'
        }} data-id="element-2188">
            The Butterfly Effect of{' '}
            <span className="text-amber-500" style={{
            textShadow: '0 0 40px rgba(217, 119, 6, 0.5)'
          }} data-id="element-2189">
              AI Hallucinations
            </span>
          </h2>

          {/* Turing quote */}
          <div className="bg-stone-950/50 border-l-4 border-amber-600 p-6 sm:p-8 my-6 sm:my-8" data-id="element-2190">
            <p className="text-sm sm:text-base text-stone-400 mb-2" data-id="element-2191">
              In 1950, Alan Turing (one of the "godfathers" of modern AI and
              computing) noted:
            </p>
            <p className="text-lg md:text-xl text-stone-100 italic leading-relaxed" data-id="element-2192">
              "The displacement of a single electron by a billionth of a
              centimetre at one moment might make the difference between a man
              being killed by an avalanche a year later, or escaping."
            </p>
          </div>

          {/* Alan Turing Portrait */}
          <div className="flex justify-center my-8" data-id="element-2193">
            <div className="relative inline-block" data-id="element-2194">
              {/* Ornate oval frame */}
              <div className="relative w-48 h-64 md:w-56 md:h-72" data-id="element-2195">
                {/* Outer glow */}
                <div className="absolute inset-0 rounded-[50%] bg-gradient-to-b from-amber-600/20 to-amber-900/20 blur-xl" data-id="element-2196" />

                {/* Frame border */}
                <div className="absolute inset-0 rounded-[50%] border-4 border-amber-600/40 shadow-[0_0_30px_rgba(217,119,6,0.3)]" data-id="element-2197" />
                <div className="absolute inset-1 rounded-[50%] border-2 border-amber-500/20" data-id="element-2198" />

                {/* Image container */}
                <div className="absolute inset-3 rounded-[50%] overflow-hidden bg-stone-900" data-id="element-2199">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nuhSeJBYyic5QEPhD1HjfW/Alan_turing_header.jpg" alt="Alan Turing" className="w-full h-full object-cover grayscale" data-id="element-2200" />
                </div>
              </div>

              {/* Name plate */}
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-stone-950 border border-amber-600/50 px-4 py-1 whitespace-nowrap" data-id="element-2201">
                <p className="text-sm text-amber-500 font-semibold tracking-wide" data-id="element-2202">
                  Alan Turing
                </p>
              </div>
            </div>
          </div>

          <p className="text-xl font-bold text-stone-100" data-id="element-2203">
            He was describing chaos theory, and what would later come to be
            known as the "butterfly effect."
          </p>

          <p className="text-lg md:text-xl text-stone-100" data-id="element-2204">
            Small changes.{' '}
            <span className="text-amber-500 font-bold" data-id="element-2205">
              Massive consequences.
            </span>
          </p>

          {/* Cascade effect */}
          <div className="space-y-4 pl-6 border-l-2 border-amber-600/30" data-id="element-2206">
            <p data-id="element-2207">A slight error in a large language model's output...</p>
            <p data-id="element-2208">Gets repeated by thousands of people who trust it...</p>
            <p data-id="element-2209">
              Gets scraped by OTHER AI tools that use it to generate MORE
              content...
            </p>
          </div>

          <p className="text-xl md:text-2xl font-bold text-stone-100" data-id="element-2210">
            And suddenly, the entire internet is littered with confidently
            incorrect information that FEELS true... but isn't.
          </p>

          {/* Transition to next section */}
          <div className="relative bg-gradient-to-br from-amber-950/30 to-black border-2 border-amber-600 p-6 sm:p-8 md:p-10 mt-12 sm:mt-16" data-id="element-2211">
            <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-amber-600" data-id="element-2212" />
            <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-amber-600" data-id="element-2213" />
            <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-amber-600" data-id="element-2214" />
            <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-amber-600" data-id="element-2215" />

            <p className="text-xl sm:text-2xl md:text-3xl text-center text-amber-500 font-bold leading-relaxed" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.5)'
          }} data-id="element-2216">
              The signal-to-noise ratio in biological optimization has reached a
              critical low.
            </p>
          </div>
        </div>
      </motion.div>

      {/* NEW SECTION: AI YouTube Channel Example */}
      <motion.div ref={ref9} initial={{
      opacity: 1,
      y: 0
    }} animate={inView9 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-2217">
        {/* Divider */}
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-2218">
          <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2219" />
          <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-2220" />
          <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2221" />
        </div>

        {/* Headline */}
        <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8 sm:mb-12" style={{
        fontFamily: 'Cinzel, serif',
        textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
      }} data-id="element-2222">
          When I Saw the Image Below, I Realized{' '}
          <span className="text-red-500" data-id="element-2223">Humanity Was In Trouble</span>
        </h3>

        {/* Image */}
        <div className="relative mb-12" data-id="element-2224">
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-600/20 to-red-600/20 rounded-lg blur" data-id="element-2225" />
          <div className="relative bg-stone-950 p-2 rounded-lg border border-amber-600/30" data-id="element-2226">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dJZbq3Yek5VH6X3WfXdXqi/b4e72e43-3622-4e89-a982-bb2047fc45f9-tinyfied.png" alt="AI-generated YouTube channel uploading daily" className="w-full rounded" data-id="element-2227" />
          </div>
        </div>

        {/* Body copy */}
        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-2228">
          <p className="text-stone-100 font-semibold" data-id="element-2229">
            I came across this entire YouTube channel that was being run 100% by
            AI.
          </p>

          <div className="bg-stone-950/50 border-l-4 border-red-600/50 p-4 sm:p-6 space-y-3" data-id="element-2230">
            <p className="text-stone-100" data-id="element-2231">
              The script?{' '}
              <span className="font-bold text-red-400" data-id="element-2232">AI-generated.</span>
            </p>
            <p className="text-stone-100" data-id="element-2233">
              The voiceover?{' '}
              <span className="font-bold text-red-400" data-id="element-2234">AI-generated.</span>
            </p>
            <p className="text-stone-100" data-id="element-2235">
              The visuals?{' '}
              <span className="font-bold text-red-400" data-id="element-2236">AI-generated.</span>
            </p>
            <p className="text-stone-100" data-id="element-2237">
              The thumbnails?{' '}
              <span className="font-bold text-red-400" data-id="element-2238">AI-generated.</span>
            </p>
            <p className="text-stone-100" data-id="element-2239">
              The music?{' '}
              <span className="font-bold text-red-400" data-id="element-2240">AI-generated.</span>
            </p>
          </div>

          <p className="text-xl md:text-2xl font-bold text-stone-100" data-id="element-2241">
            It was churning out{' '}
            <span className="text-red-500" style={{
            textShadow: '0 0 20px rgba(239, 68, 68, 0.4)'
          }} data-id="element-2242">
              VIRAL
            </span>{' '}
            content. <span className="text-amber-500" data-id="element-2243">Every. Single. Day.</span>
          </p>

          <div className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 space-y-3" data-id="element-2244">
            <p data-id="element-2245">Long videos.</p>
            <p data-id="element-2246">Thousands of views.</p>
            <p data-id="element-2247">Climbing the algorithm.</p>
          </div>

          <p className="text-2xl md:text-3xl font-bold text-center text-red-500 mt-6 sm:mt-8" data-id="element-2248">
            And almost{' '}
            <span style={{
            textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
          }} data-id="element-2249">
              NOBODY
            </span>{' '}
            in the comments realized it was fake.
          </p>

          {/* NEW SECTION: FDR Hallucination */}
          <div className="space-y-8 sm:space-y-12 mt-12 sm:mt-16" data-id="element-2250">
            <p className="text-2xl md:text-3xl font-bold text-stone-100" data-id="element-2251">
              But here's where it gets{' '}
              <span className="text-red-500" style={{
              textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
            }} data-id="element-2252">
                insidious
              </span>
              ...
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-semibold" data-id="element-2253">
              In one of the videos, the AI hallucinated a "fact."
            </p>

            <p className="text-lg sm:text-xl text-stone-100 border-l-4 border-red-600 pl-4 sm:pl-6 py-2 bg-red-950/10" data-id="element-2254">
              It confidently stated that{' '}
              <span className="font-bold text-red-400" data-id="element-2255">
                Franklin Delano Roosevelt
              </span>{' '}
              is the president on Mount Rushmore.
            </p>

            {/* FDR Image */}
            <div className="relative my-8" data-id="element-2256">
              <div className="absolute -inset-1 bg-gradient-to-r from-red-600/20 to-amber-600/20 rounded-lg blur" data-id="element-2257" />
              <div className="relative bg-stone-950 p-2 rounded-lg border border-red-600/30" data-id="element-2258">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aFRrizYEorcBCvdGpoiDKS/FDR-Visual-tinyfied.png" alt="AI-generated FDR visual from video" className="w-full rounded" data-id="element-2259" />
              </div>
            </div>

            <p className="text-2xl md:text-3xl font-bold text-stone-100" data-id="element-2260">
              Except... FDR is{' '}
              <span className="text-red-500 uppercase" style={{
              textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
            }} data-id="element-2261">
                NOT
              </span>{' '}
              the Roosevelt on Mount Rushmore.
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-semibold pl-4 sm:pl-6 border-l-2 border-amber-600/30" data-id="element-2262">
              In reality that's{' '}
              <span className="text-amber-500 font-bold" data-id="element-2263">
                Theodore Roosevelt
              </span>
              .
            </p>

            <p className="text-xl md:text-2xl font-bold text-stone-100" data-id="element-2264">
              But the AI didn't stop there.
            </p>

            <p className="text-lg sm:text-xl text-red-400 font-semibold" data-id="element-2265">
              It then GENERATED an image of FDR... ON Mount Rushmore.
            </p>

            {/* FDR on Mount Rushmore Image */}
            <div className="relative my-8" data-id="element-2266">
              <div className="absolute -inset-1 bg-gradient-to-r from-red-600/30 to-red-600/30 rounded-lg blur-lg" data-id="element-2267" />
              <div className="relative bg-stone-950 p-2 rounded-lg border-2 border-red-600/50" data-id="element-2268">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fRUyWfrFdHjTMpduYvvgb3/FDR-On-Mt-Rushmore-tinyfied.png" alt="AI-generated image of FDR on Mount Rushmore" className="w-full rounded" data-id="element-2269" />
              </div>
            </div>

            <p className="text-2xl md:text-3xl font-bold text-center text-red-500" style={{
            textShadow: '0 0 40px rgba(239, 68, 68, 0.6)'
          }} data-id="element-2270">
              Reinforcing its OWN hallucination.
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-semibold mt-6 sm:mt-8" data-id="element-2271">
              And the comments?
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-semibold" data-id="element-2272">
              Almost nobody caught it.
            </p>

            <p className="text-3xl md:text-4xl font-bold text-center text-stone-100 mt-6 sm:mt-8" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.3)'
          }} data-id="element-2273">
              People just... believed it.
            </p>
          </div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 my-8 sm:my-12" data-id="element-2274">
            <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-red-600/50 to-red-600/50" data-id="element-2275" />
            <div className="w-2 h-2 bg-red-600 rotate-45" data-id="element-2276" />
            <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-red-600/50 to-red-600/50" data-id="element-2277" />
          </div>

          {/* Health Connection */}
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8 sm:mb-12" style={{
          fontFamily: 'Cinzel, serif',
          textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
        }} data-id="element-2278">
            But It's Not Just History. It's Your{' '}
            <span className="text-red-500" style={{
            textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
          }} data-id="element-2279">
              HEALTH
            </span>
            .
          </h3>

          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-2280">
            <p className="text-xl md:text-2xl text-stone-100 font-semibold" data-id="element-2281">
              Now imagine that same process happening with PEPTIDES.
            </p>

            <div className="pl-4 sm:pl-6 border-l-2 border-red-600/50 space-y-4 text-base sm:text-lg" data-id="element-2282">
              <p className="text-stone-100" data-id="element-2283">
                With molecules you're putting into{' '}
                <span className="font-bold text-red-400" data-id="element-2284">YOUR</span> body.
              </p>
              <p className="text-stone-100" data-id="element-2285">
                With advice that affects{' '}
                <span className="font-bold text-red-400" data-id="element-2286">YOUR</span> brain,{' '}
                <span className="font-bold text-red-400" data-id="element-2287">YOUR</span> organs,{' '}
                <span className="font-bold text-red-400" data-id="element-2288">YOUR</span> wellbeing.
              </p>
            </div>

            <p className="text-xl md:text-2xl font-bold text-stone-100" data-id="element-2289">
              Because it's already happening.
            </p>

            <p className="text-2xl md:text-3xl font-bold text-center text-amber-500 mt-6 sm:mt-8" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
          }} data-id="element-2290">
              Let me show you.
            </p>
          </div>

          {/* Divider */}

          {/* Section 1: Elon/LeBron */}
          <div className="space-y-8" data-id="element-2291"></div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 mt-8 sm:mt-16" data-id="element-2292">
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2293" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-2294" />
            <div className="w-24 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2295" />
          </div>

          {/* Section 2: BPC-157 vs Vesugen */}
          <div className="space-y-8" data-id="element-2296">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-center text-stone-100 leading-tight" style={{
            fontFamily: 'Cinzel, serif'
          }} data-id="element-2297">
              <span className="text-yellow-400" style={{
              textShadow: '0 0 30px rgba(234, 179, 8, 0.4)'
            }} data-id="element-2298">
                AI Does Not Know What It's Saying
              </span>
              {' - '}
              <span className="text-yellow-300" data-id="element-2299">Example #1</span>
            </h3>

            <div className="text-lg md:text-xl text-stone-300 space-y-6 leading-relaxed" data-id="element-2300">
              <p data-id="element-2301">
                ChatGPT was asked to list the best peptides for vascular health.
              </p>

              <p data-id="element-2302">
                It confidently listed{' '}
                <span className="text-stone-100 font-bold" data-id="element-2303">
                  BPC-157, TB-500, and others.
                </span>
              </p>

              <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-red-600 pl-4 sm:pl-6 py-2 bg-red-950/10" data-id="element-2304">
                But somehow it SKIPPED what should have been the absolute top
                recommendation – <span className="text-red-400" data-id="element-2305">Vesugen</span>.
              </p>

              {/* Image */}
              <div className="relative my-8 max-w-2xl mx-auto" data-id="element-2306">
                <div className="absolute -inset-1 bg-gradient-to-r from-red-600/20 to-amber-600/20 rounded-lg blur opacity-75" data-id="element-2307" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9d6nVvQcppnhCKKcbixi1c/ChatGPTSkippedVesugen-tinyfied.png" alt="ChatGPT skipping Vesugen" className="relative rounded-lg border border-stone-800 w-full" data-id="element-2308" />
              </div>

              <p data-id="element-2309">
                And when pressed, it claimed Vesugen didn't have enough
                scientific backing.
              </p>

              <p className="italic text-stone-400" data-id="element-2310">
                Except Brenden Henry provided{' '}
                <span className="text-stone-100 font-bold not-italic" data-id="element-2311">
                  60+ scientific citations
                </span>{' '}
                to real studies in a video proving Vesugen's effectiveness for
                vascular health.
              </p>

              <p data-id="element-2312">
                Most "influencers" and "experts" take the generic, surface-level
                approach of recommending BPC-157 for almost everything…
              </p>

              <p className="text-stone-100 font-bold" data-id="element-2313">
                And ChatGPT simply followed suit.
              </p>

              <p data-id="element-2314">
                It just... guessed. Based on all the data it's been trained on.
              </p>

              <p className="text-2xl font-bold text-red-500" data-id="element-2315">
                And it's largely BS.
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 mt-8 sm:mt-16" data-id="element-2316">
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2317" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-2318" />
            <div className="w-24 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2319" />
          </div>

          {/* Section 3: Inventing New Peptides */}
          <div className="space-y-8" data-id="element-2320">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-center text-stone-100 leading-tight" style={{
            fontFamily: 'Cinzel, serif'
          }} data-id="element-2321">
              <span className="text-yellow-400" style={{
              textShadow: '0 0 30px rgba(234, 179, 8, 0.4)'
            }} data-id="element-2322">
                AI Does Not Know What It's Saying
              </span>
              {' - '}
              <span className="text-yellow-300" data-id="element-2323">Example #2</span>
            </h3>

            <div className="text-lg md:text-xl text-stone-300 space-y-6 leading-relaxed" data-id="element-2324">
              <p data-id="element-2325">
                I recently asked ChatGPT for the best peptides for brain
                restoration.
              </p>

              <p className="font-bold text-stone-100" data-id="element-2326">It confidently listed:</p>

              <ul className="space-y-4 pl-4 border-l-2 border-stone-800 text-base sm:text-lg" data-id="element-2327">
                <li data-id="element-2328">
                  <span className="text-amber-500 font-bold" data-id="element-2329">Bronchogen</span>{' '}
                  <span className="text-stone-400" data-id="element-2330">
                    (which, at the time of writing, has zero evidence in
                    scientific literature that it does ANYTHING for the brain)
                  </span>
                </li>
                <li data-id="element-2331">
                  <span className="text-amber-500 font-bold" data-id="element-2332">Cardiogen</span>{' '}
                  <span className="text-stone-400" data-id="element-2333">
                    (while it's possible it could indirectly help restore the
                    brain, at the time of writing there's also no literature
                    backing up ChatGPT's assertion)
                  </span>
                </li>
              </ul>

              <p className="text-lg sm:text-xl text-stone-100 font-bold mt-6" data-id="element-2334">
                But then it listed a peptide called "Cortexgen"
              </p>

              {/* Image */}
              <div className="relative my-8 max-w-2xl mx-auto" data-id="element-2335">
                <div className="absolute -inset-1 bg-gradient-to-r from-amber-600/20 to-red-600/20 rounded-lg blur opacity-75" data-id="element-2336" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3nt8h71t9XkgavNxaiVqUD/ChatGPTCortexgenHallucination.png" alt="ChatGPT hallucinating Cortexgen" className="relative rounded-lg border border-stone-800 w-full" data-id="element-2337" />
              </div>

              <p className="text-2xl font-bold text-red-500 text-center" data-id="element-2338">
                Except "Cortexgen" doesn't exist.
              </p>

              <p className="text-center font-medium text-stone-100" data-id="element-2339">
                It just... made it up.
              </p>

              <p data-id="element-2340">
                Probably mashed together Cortexin and Cortagen in its neural
                network and spit out a fake name.
              </p>

              <p className="text-xl font-bold text-stone-100 border-b-2 border-amber-600/30 pb-2 inline-block" data-id="element-2341">
                But that's not the worst of it...
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 mt-16 sm:mt-20" data-id="element-2342">
            <div className="w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2343" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-2344" />
            <div className="w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2345" />
          </div>

          {/* NEW SECTION: And Humans Are Making It Worse */}
          <div className="space-y-8" data-id="element-2346">
            <h3 className="text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
          }} data-id="element-2347">
              Because Humans Are Making It{' '}
              <span className="text-red-500" style={{
              textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
            }} data-id="element-2348">
                Worse
              </span>
            </h3>

            <div className="text-lg md:text-xl text-stone-300 space-y-6 leading-relaxed" data-id="element-2349">
              <p className="text-stone-100 font-semibold" data-id="element-2350">
                Here's the thing: Even if YOU don't use AI and you don't have to
                deal with its hallucinations directly...
              </p>

              <p className="text-stone-100 font-semibold" data-id="element-2351">
                Here's the thing...
              </p>

              <p className="text-amber-500 font-bold" style={{
              textShadow: '0 0 20px rgba(217, 119, 6, 0.3)'
            }} data-id="element-2352">
                Most influencers (and even many experts) don't fact-check.
              </p>

              <div className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 space-y-3" data-id="element-2353">
                <p data-id="element-2354">They pull up ChatGPT.</p>
                <p data-id="element-2355">Ask it to summarize a topic.</p>
                <p data-id="element-2356">Record a video reading the AI script.</p>
                <p data-id="element-2357">And assume it's correct.</p>
              </div>

              <p data-id="element-2358">
                Because it{' '}
                <span className="font-bold text-stone-100 uppercase" data-id="element-2359">
                  SOUNDS
                </span>{' '}
                correct.
              </p>

              <p data-id="element-2360">
                And their audience assumes{' '}
                <span className="font-bold text-stone-100 uppercase" data-id="element-2361">THEY</span>{' '}
                did the research.
              </p>

              <p className="text-xl font-bold text-stone-100" data-id="element-2362">
                But they didn't.
              </p>

              <p className="text-xl font-bold text-stone-100" data-id="element-2363">Nobody did.</p>

              <p className="text-stone-100 italic" data-id="element-2364">
                And everyone is just putting the responsibility on someone (or
                some<span className="font-bold" data-id="element-2365">THING</span>) else.
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 mt-8 sm:mt-16" data-id="element-2366">
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2367" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-2368" />
            <div className="w-24 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2369" />
          </div>

          {/* NEW SECTION: The Feedback Loop From Hell */}
          <div className="space-y-8" data-id="element-2370">
            <h3 className="text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
          }} data-id="element-2371">
              The Feedback Loop From{' '}
              <span className="text-red-500" style={{
              textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
            }} data-id="element-2372">
                Hell
              </span>
            </h3>

            <div className="text-lg md:text-xl text-stone-300 space-y-6 leading-relaxed" data-id="element-2373">
              <p className="text-stone-100 font-semibold" data-id="element-2374">
                Here's what's happening in real-time:
              </p>

              <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-red-600/50 text-base sm:text-lg" data-id="element-2375">
                <p data-id="element-2376">→ AI or a human shares misinformation</p>
                <p data-id="element-2377">→ Humans spread it because it sounds right</p>
                <p data-id="element-2378">→ Humans generate more content with that misinformation</p>
                <p data-id="element-2379">
                  → Other AI tools scrape that misinformation and use it to
                  generate even{' '}
                  <span className="font-bold text-stone-100 uppercase" data-id="element-2380">
                    MORE
                  </span>{' '}
                  content
                </p>
                <p data-id="element-2381">→ That content gets indexed, shared, and trusted</p>
                <p data-id="element-2382">→ The cycle repeats</p>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2383">
                Each iteration adds{' '}
                <span className="text-red-500 uppercase" data-id="element-2384">MORE</span> noise.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2385">
                Each iteration buries the truth{' '}
                <span className="text-red-500 uppercase" data-id="element-2386">DEEPER</span>.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2387">
                Each iteration makes it harder to know what's real.
              </p>

              <p className="text-xl sm:text-2xl font-bold text-center text-amber-500 mt-6 sm:mt-8" style={{
              textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
            }} data-id="element-2388">
                And your body pays the price.
              </p>
            </div>
          </div>

          {/* Divider */}

          {/* NEW SECTION: The Era of Accelerating Misinformation */}
          <motion.div ref={ref12} initial={{
          opacity: 0,
          y: 20
        }} animate={inView12 ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4
        }} className="mt-20" data-id="element-2389">
            {/* Divider */}
            <div className="flex items-center justify-center gap-4 mb-12" data-id="element-2390">
              <div className="w-32 h-px bg-gradient-to-r from-transparent via-red-600/50 to-red-600/50" data-id="element-2391" />
              <div className="w-2 h-2 bg-red-600 rotate-45" data-id="element-2392" />
              <div className="w-32 h-px bg-gradient-to-l from-transparent via-red-600/50 to-red-600/50" data-id="element-2393" />
            </div>

            <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-2394">
              <h3 className="text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8" style={{
              fontFamily: 'Cinzel, serif',
              textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
            }} data-id="element-2395">
                The Era of{' '}
                <span className="text-red-500" style={{
                textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
              }} data-id="element-2396">
                  Accelerating Misinformation
                </span>{' '}
                Is Already Here.
              </h3>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2397">
                Let me show you how bad it's gotten.
              </p>

              <p data-id="element-2398">You just saw that AI-generated YouTube channel.</p>

              <p data-id="element-2399">The one that hallucinated FDR onto Mount Rushmore.</p>

              <p className="text-stone-100 font-semibold" data-id="element-2400">
                That video has been viewed thousands of times.
              </p>

              <p className="text-stone-100 font-semibold" data-id="element-2401">
                And almost nobody in the comments caught the error.
              </p>

              <div className="pl-4 sm:pl-6 border-l-2 border-red-600/50 space-y-4 my-6 sm:my-8 text-base sm:text-lg" data-id="element-2402">
                <p className="text-stone-100" data-id="element-2403">
                  Which means thousands of people now "know" that FDR is on
                  Mount Rushmore.
                </p>

                <p data-id="element-2404">They'll repeat it.</p>

                <p data-id="element-2405">They'll share it.</p>

                <p data-id="element-2406">They'll use it as a "fact" in THEIR content.</p>

                <p className="text-red-400 font-bold" data-id="element-2407">
                  And the misinformation spreads.
                </p>
              </div>

              <p className="text-xl md:text-2xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-2408">
                Now imagine that same process happening with peptides.
              </p>

              <div className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 space-y-3 text-base sm:text-lg" data-id="element-2409">
                <p data-id="element-2410">With dosing protocols.</p>
                <p data-id="element-2411">With drug interactions.</p>
                <p data-id="element-2412">With contraindications.</p>
                <p data-id="element-2413">With mechanisms of action.</p>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6" data-id="element-2414">
                Except instead of just getting history wrong...
              </p>

              <p className="text-xl sm:text-2xl font-bold text-red-500" style={{
              textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
            }} data-id="element-2415">
                People are putting the WRONG molecules into their bodies.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2416">
                Or worse...
              </p>

              <p className="text-lg sm:text-xl font-bold text-red-400" data-id="element-2417">
                Recommending the wrong molecules to their clients.
              </p>

              <div className="bg-red-950/20 border-l-4 border-red-600 p-4 sm:p-6 my-6 sm:my-8 space-y-4 text-base sm:text-lg" data-id="element-2418">
                <p className="text-stone-100" data-id="element-2419">
                  Based on information that was hallucinated by an AI...
                </p>
                <p className="text-stone-100" data-id="element-2420">
                  Spread by an influencer who didn't fact-check...
                </p>
                <p className="text-stone-100" data-id="element-2421">
                  Validated by MORE AI that scraped the bad information...
                </p>
                <p className="text-stone-100" data-id="element-2422">
                  And reinforced by thousands of people who believed it because
                  it SOUNDED right.
                </p>
              </div>
            </div>
          </motion.div>

          {/* NEW SECTION: Most People Are Working With the WRONG MAP */}
          <motion.div ref={ref13} initial={{
          opacity: 0,
          y: 20
        }} animate={inView13 ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4
        }} className="mt-20" data-id="element-2423">
            {/* Divider */}
            <div className="flex items-center justify-center gap-4 mb-12" data-id="element-2424">
              <div className="w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2425" />
              <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-2426" />
              <div className="w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2427" />
            </div>

            <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-2428">
              <h3 className="text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8" style={{
              fontFamily: 'Cinzel, serif',
              textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
            }} data-id="element-2429">
                Most People Are Working With the{' '}
                <span className="text-amber-500" style={{
                textShadow: '0 0 30px rgba(217, 119, 6, 0.5)'
              }} data-id="element-2430">
                  WRONG MAP
                </span>
              </h3>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2431">
                Let me show you what I mean.
              </p>

              <p data-id="element-2432">
                Most people think the problem with peptides is just "bad
                information."
              </p>

              <div className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 space-y-3" data-id="element-2433">
                <p data-id="element-2434">Like if you could just filter out the noise...</p>
                <p data-id="element-2435">Find the "good sources"...</p>
                <p data-id="element-2436">Follow the "right protocols"...</p>
                <p data-id="element-2437">Then you'd be set.</p>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2438">
                But that's not how this works.
              </p>

              <p className="text-stone-100 font-semibold" data-id="element-2439">
                Because even the BEST information out there...
              </p>

              <p data-id="element-2440">Even from the most "credible" experts...</p>

              <p data-id="element-2441">
                Even from doctors with fancy credentials and big followings...
              </p>

              <p className="text-xl sm:text-2xl font-bold text-amber-500" style={{
              textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
            }} data-id="element-2442">
                Is still missing the most important pieces.
              </p>

              <div className="bg-stone-950/50 border-2 border-amber-600/30 p-6 sm:p-8 my-6 sm:my-8" data-id="element-2443">
                <p className="text-lg sm:text-xl font-bold text-stone-100 mb-4 sm:mb-6" data-id="element-2444">
                  Here's what they DON'T have:
                </p>

                <div className="space-y-4 text-base sm:text-lg" data-id="element-2445">
                  <div className="flex items-start gap-3" data-id="element-2446">
                    <XCircle className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-2447" />
                    <p className="text-stone-300" data-id="element-2448">
                      Access to and understanding of original Russian research
                      papers (most of it has NEVER been translated to English)
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-2449">
                    <XCircle className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-2450" />
                    <p className="text-stone-300" data-id="element-2451">
                      Understanding of all three types of bioregulators (they
                      only know about Version 1)
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-2452">
                    <XCircle className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-2453" />
                    <p className="text-stone-300" data-id="element-2454">
                      Knowledge of the "super peptides" Brenden identified
                      (bioaugmentors that almost nobody else knows exist)
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-2455">
                    <XCircle className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-2456" />
                    <p className="text-stone-300" data-id="element-2457">
                      Real-world experience creating "impossible"
                      transformations (they're working from theory, not proven
                      results)
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-2458">
                    <XCircle className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-2459" />
                    <p className="text-stone-300" data-id="element-2460">
                      The diagnostic frameworks that allow you to spot root
                      causes instead of just treating symptoms
                    </p>
                  </div>
                </div>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2461">
                So when they teach peptides...
              </p>

              <p data-id="element-2462">When they recommend protocols...</p>

              <p data-id="element-2463">When they answer your questions...</p>

              <p className="text-stone-100 font-semibold" data-id="element-2464">
                They're giving you the BEST answer they can...
              </p>

              <p className="text-xl sm:text-2xl font-bold text-amber-500" style={{
              textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
            }} data-id="element-2465">
                Based on an incomplete understanding of what's actually
                possible.
              </p>

              <div className="bg-gradient-to-br from-amber-950/30 to-black border-2 border-amber-600 p-6 sm:p-8 md:p-10 mt-6 sm:mt-8 relative" data-id="element-2466">
                <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-amber-600" data-id="element-2467" />
                <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-amber-600" data-id="element-2468" />
                <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-amber-600" data-id="element-2469" />
                <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-amber-600" data-id="element-2470" />

                <p className="text-xl sm:text-2xl md:text-3xl text-center text-stone-100 font-bold leading-relaxed" style={{
                textShadow: '0 0 20px rgba(217, 119, 6, 0.3)'
              }} data-id="element-2471">
                  It's like trying to navigate with a map that's missing half
                  the territory.
                </p>
              </div>

              <p className="text-lg sm:text-xl text-stone-100 mt-6 sm:mt-8" data-id="element-2472">
                You might get SOMEWHERE.
              </p>

              <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-amber-500" style={{
              textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
            }} data-id="element-2473">
                But you'll never reach the destinations that aren't even ON your
                map.
              </p>
            </div>
          </motion.div>

          {/* NEW SECTION: There's A Shift That MUST Happen */}
          <motion.div ref={ref14} initial={{
          opacity: 0,
          y: 20
        }} animate={inView14 ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4
        }} className="mt-12 sm:mt-20" data-id="element-2474">
            {/* Divider with blue accent */}
            <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-2475">
              <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-blue-500/50 to-blue-500/50" data-id="element-2476" />
              <div className="w-2 h-2 bg-blue-500 rotate-45" data-id="element-2477" />
              <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-blue-500/50 to-blue-500/50" data-id="element-2478" />
            </div>

            <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-2479">
              <h3 className="text-2xl sm:text-3xl md:text-5xl font-serif font-bold text-center text-stone-100 mb-6 sm:mb-8 leading-tight" style={{
              fontFamily: 'Cinzel, serif',
              textShadow: '0 0 20px rgba(59, 130, 246, 0.3)'
            }} data-id="element-2480">
                There's A Shift That{' '}
                <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent" style={{
                textShadow: '0 0 30px rgba(59, 130, 246, 0.5)'
              }} data-id="element-2481">
                  MUST
                </span>{' '}
                Happen
              </h3>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2482">
                Here's what most people don't understand:
              </p>

              <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-2483">
                You can't just "learn more information" and expect to operate at
                the level Brenden and Ali do.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2484">
                Because mastery isn't about VOLUME of knowledge.
              </p>

              <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent" style={{
              textShadow: '0 0 30px rgba(59, 130, 246, 0.4)'
            }} data-id="element-2485">
                It's about the PARADIGM you're operating from.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-2486">
                Let me explain.
              </p>

              <div className="bg-gradient-to-br from-blue-950/30 via-stone-950/50 to-black border-l-4 border-blue-500/50 p-6 sm:p-8 my-6 sm:my-8" data-id="element-2487">
                <p className="text-lg sm:text-xl text-stone-100 font-bold mb-4" data-id="element-2488">
                  Right now, most people (including most "experts") are
                  operating from a FRAGMENTED paradigm.
                </p>

                <div className="space-y-3 pl-4 sm:pl-6 border-l-2 border-blue-400/30 text-base sm:text-lg" data-id="element-2489">
                  <p data-id="element-2490">They know bits and pieces.</p>
                  <p data-id="element-2491">They understand isolated mechanisms.</p>
                  <p data-id="element-2492">They can recommend protocols that "should" work.</p>
                </div>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2493">
                But they don't have the COMPLETE PICTURE.
              </p>

              <div className="pl-4 sm:pl-6 border-l-2 border-blue-500/30 space-y-3 text-base sm:text-lg" data-id="element-2494">
                <p data-id="element-2495">They've never seen the original research.</p>
                <p data-id="element-2496">They don't understand how all the pieces fit together.</p>
                <p data-id="element-2497">
                  They don't know what's ACTUALLY possible when you understand
                  peptides at the highest level.
                </p>
              </div>

              <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-2498">
                So their "best recommendations" are still limited by their
                incomplete understanding.
              </p>

              <div className="bg-gradient-to-br from-stone-950/80 via-blue-950/20 to-black border-2 border-blue-500/30 p-6 sm:p-8 my-6 sm:my-8 relative" data-id="element-2499">
                <div className="absolute top-0 left-0 w-5 sm:w-6 h-5 sm:h-6 border-l-2 border-t-2 border-blue-500/50" data-id="element-2500" />
                <div className="absolute top-0 right-0 w-5 sm:w-6 h-5 sm:h-6 border-r-2 border-t-2 border-blue-500/50" data-id="element-2501" />
                <div className="absolute bottom-0 left-0 w-5 sm:w-6 h-5 sm:h-6 border-l-2 border-b-2 border-blue-500/50" data-id="element-2502" />
                <div className="absolute bottom-0 right-0 w-5 sm:w-6 h-5 sm:h-6 border-r-2 border-b-2 border-blue-500/50" data-id="element-2503" />

                <p className="text-lg sm:text-xl md:text-2xl text-center text-stone-100 leading-relaxed italic" data-id="element-2504">
                  It's like trying to complete a 1,000-piece puzzle...
                </p>
                <p className="text-lg sm:text-xl md:text-2xl text-center text-stone-100 mt-4 leading-relaxed italic" data-id="element-2505">
                  When you've only been given 200 pieces.
                </p>
              </div>

              <p className="text-stone-100 text-base sm:text-lg" data-id="element-2506">
                You can make SOMETHING.
              </p>

              <p className="text-xl sm:text-2xl font-bold text-blue-400" style={{
              textShadow: '0 0 30px rgba(59, 130, 246, 0.4)'
            }} data-id="element-2507">
                But it'll never be the full picture.
              </p>

              <div className="bg-gradient-to-br from-blue-950/30 via-cyan-950/20 to-black border-2 border-cyan-500 p-6 sm:p-8 md:p-10 mt-8 sm:mt-12 relative" data-id="element-2508">
                <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-cyan-500" data-id="element-2509" />
                <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-cyan-500" data-id="element-2510" />
                <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-cyan-500" data-id="element-2511" />
                <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-cyan-500" data-id="element-2512" />

                <p className="text-lg sm:text-xl md:text-2xl text-stone-100 font-bold mb-4" data-id="element-2513">
                  The paradigm shift is about getting ALL the pieces.
                </p>

                <div className="space-y-3 text-base sm:text-lg" data-id="element-2514">
                  <p className="text-stone-100" data-id="element-2515">
                    It's about seeing the COMPLETE map.
                  </p>
                  <p className="text-stone-100" data-id="element-2516">
                    It's about understanding the PRINCIPLES behind the
                    protocols...
                  </p>
                  <p className="text-cyan-400 font-bold" style={{
                  textShadow: '0 0 20px rgba(34, 211, 238, 0.4)'
                }} data-id="element-2517">
                    So you can design your OWN solutions for ANY situation.
                  </p>
                </div>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-2518">
                This shift is what separates the masters from everyone else.
              </p>

              <p className="text-stone-100" data-id="element-2519">
                And it's what allows Brenden and Ali to look at "hopeless"
                cases...
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2520">
                And see exactly what needs to be done.
              </p>

              <div className="bg-gradient-to-br from-blue-950/30 to-black border-2 border-blue-500/40 p-6 sm:p-8 my-6 sm:my-8" data-id="element-2521">
                <p className="text-lg sm:text-xl text-blue-400 font-bold mb-4" data-id="element-2522">
                  During PSI PRO, Brenden and Ali are going to GIVE you this
                  paradigm shift.
                </p>

                <div className="space-y-3 pl-4 sm:pl-6 border-l-2 border-cyan-500/30" data-id="element-2523">
                  <p className="text-stone-100" data-id="element-2524">
                    They're going to show you the complete picture.
                  </p>
                  <p className="text-stone-100" data-id="element-2525">
                    They're going to reveal the principles that govern
                    biological optimization.
                  </p>
                  <p className="text-stone-100" data-id="element-2526">
                    They're going to teach you how to THINK like a master...
                  </p>
                  <p className="text-stone-100 italic" data-id="element-2527">
                    Not just follow templates like everyone else.
                  </p>
                </div>
              </div>

              <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-cyan-400 mt-6 sm:mt-8" style={{
              textShadow: '0 0 30px rgba(34, 211, 238, 0.4)'
            }} data-id="element-2528">
                And once you make this shift...
              </p>

              <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-stone-100" style={{
              textShadow: '0 0 20px rgba(59, 130, 246, 0.3)'
            }} data-id="element-2529">
                Everything changes.
              </p>

              <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-blue-500/30 mt-6 sm:mt-8 text-base sm:text-lg" data-id="element-2530">
                <p className="text-stone-100" data-id="element-2531">
                  You'll look at bloodwork differently.
                </p>
                <p className="text-stone-100" data-id="element-2532">
                  You'll design protocols differently.
                </p>
                <p className="text-stone-100" data-id="element-2533">
                  You'll solve problems differently.
                </p>
                <p className="text-stone-100 font-bold" data-id="element-2534">
                  You'll operate at a level most practitioners will NEVER reach.
                </p>
              </div>

              <p className="text-lg sm:text-xl text-stone-100 text-center mt-6 sm:mt-8 italic" data-id="element-2535">
                And you'll wonder how you ever functioned without seeing the
                full picture.
              </p>
            </div>
          </motion.div>

          {/* NEW SECTION: Accessing Powers Beyond The Mainstream */}
          <motion.div ref={ref15} initial={{
          opacity: 0,
          y: 20
        }} animate={inView15 ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4
        }} className="mt-12 sm:mt-20" data-id="element-2536">
            {/* Divider with purple/green gradient */}
            <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-2537">
              <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-purple-500/50 to-green-500/50" data-id="element-2538" />
              <div className="w-2 h-2 bg-gradient-to-br from-purple-500 to-green-500 rotate-45" data-id="element-2539" />
              <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-green-500/50 to-purple-500/50" data-id="element-2540" />
            </div>

            <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-2541">
              <h3 className="text-2xl sm:text-3xl md:text-5xl font-serif font-bold text-center text-stone-100 mb-6 sm:mb-8 leading-tight" style={{
              fontFamily: 'Cinzel, serif',
              textShadow: '0 0 20px rgba(168, 85, 247, 0.3)'
            }} data-id="element-2542">
                This Is About Accessing{' '}
                <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-green-400 bg-clip-text text-transparent" style={{
                textShadow: '0 0 30px rgba(168, 85, 247, 0.5)'
              }} data-id="element-2543">
                  Powers Beyond The Mainstream
                </span>
              </h3>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2544">
                Let me be clear about what I mean.
              </p>

              <p className="text-stone-100" data-id="element-2545">
                When I say "powers beyond the mainstream"...
              </p>

              <p className="text-xl sm:text-2xl font-bold text-stone-100" data-id="element-2546">
                I'm not talking about some woo-woo mystical bullsh**t.
              </p>

              <p className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-purple-400 to-green-400 bg-clip-text text-transparent" style={{
              textShadow: '0 0 30px rgba(168, 85, 247, 0.4)'
            }} data-id="element-2547">
                I'm talking about biological capabilities that are
                scientifically validated...
              </p>

              <p className="text-lg sm:text-xl text-stone-100 font-semibold" data-id="element-2548">
                But almost completely unknown outside of elite research circles.
              </p>

              <div className="bg-gradient-to-br from-purple-950/30 via-stone-950/50 to-green-950/20 border-2 border-purple-500/40 p-6 sm:p-8 my-6 sm:my-8" data-id="element-2549">
                <p className="text-lg sm:text-xl font-bold text-purple-400 mb-4 sm:mb-6" data-id="element-2550">
                  Capabilities like:
                </p>

                <div className="space-y-4 text-base sm:text-lg" data-id="element-2551">
                  <div className="flex items-start gap-3" data-id="element-2552">
                    <span className="text-green-400 text-xl flex-shrink-0" data-id="element-2553">
                      →
                    </span>
                    <p className="text-stone-100" data-id="element-2554">
                      Reversing cognitive decline that neurologists said was
                      "permanent"
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-2555">
                    <span className="text-green-400 text-xl flex-shrink-0" data-id="element-2556">
                      →
                    </span>
                    <p className="text-stone-100" data-id="element-2557">
                      Restoring heart function that cardiologists said required
                      a transplant
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-2558">
                    <span className="text-green-400 text-xl flex-shrink-0" data-id="element-2559">
                      →
                    </span>
                    <p className="text-stone-100" data-id="element-2560">
                      Regenerating tissues that mainstream medicine considers
                      "impossible to heal"
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-2561">
                    <span className="text-green-400 text-xl flex-shrink-0" data-id="element-2562">
                      →
                    </span>
                    <p className="text-stone-100" data-id="element-2563">
                      Optimizing biological markers in ways that make doctors
                      ask "what are you doing?"
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-2564">
                    <span className="text-green-400 text-xl flex-shrink-0" data-id="element-2565">
                      →
                    </span>
                    <p className="text-stone-100" data-id="element-2566">
                      Accessing energy, clarity, and performance levels you
                      didn't know were possible
                    </p>
                  </div>
                </div>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2567">
                This isn't theory.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2568">
                This isn't speculation.
              </p>

              <p className="text-xl sm:text-2xl font-bold text-center bg-gradient-to-r from-purple-400 to-green-400 bg-clip-text text-transparent" style={{
              textShadow: '0 0 30px rgba(168, 85, 247, 0.4)'
            }} data-id="element-2569">
                This is what happens when you understand peptides and compounds
                at the level Brenden and Ali do.
              </p>

              <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-purple-500/30 mt-6 sm:mt-8 text-base sm:text-lg" data-id="element-2570">
                <p className="text-stone-100" data-id="element-2571">
                  When you know which molecules to use.
                </p>
                <p className="text-stone-100" data-id="element-2572">
                  How to stack them for synergistic effects.
                </p>
                <p className="text-stone-100" data-id="element-2573">
                  How to dose them for maximum bioavailability.
                </p>
                <p className="text-stone-100" data-id="element-2574">
                  How to sequence them for optimal results.
                </p>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-2575">
                And most importantly...
              </p>

              <div className="bg-gradient-to-br from-purple-950/30 via-green-950/20 to-black border-2 border-green-500 p-6 sm:p-8 md:p-10 mt-6 sm:mt-8 relative" data-id="element-2576">
                <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-purple-500" data-id="element-2577" />
                <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-green-500" data-id="element-2578" />
                <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-green-500" data-id="element-2579" />
                <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-purple-500" data-id="element-2580" />

                <p className="text-xl sm:text-2xl md:text-3xl text-center bg-gradient-to-r from-purple-400 via-pink-400 to-green-400 bg-clip-text text-transparent font-bold leading-relaxed" style={{
                textShadow: '0 0 30px rgba(168, 85, 247, 0.5)'
              }} data-id="element-2581">
                  When you understand the Precision Cell™ method.
                </p>
              </div>
            </div>
          </motion.div>

          {/* NEW SECTION: The Precision Cell™ Method */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mt-20 sm:mt-32" data-id="element-2582">
            {/* Dramatic Divider with Emerald/Teal gradient */}
            <div className="flex items-center justify-center gap-4 mb-10 sm:mb-16" data-id="element-2583">
              <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-emerald-500/60 to-teal-500/60" data-id="element-2584" />
              <motion.div animate={{
              scale: [1, 1.2, 1],
              rotate: [0, 180, 360]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="w-3 h-3 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-full" data-id="element-2585" />
              <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-teal-500/60 to-emerald-500/60" data-id="element-2586" />
            </div>

            {/* Main Headline - Dramatic and Eye-Catching */}
            <div className="relative mb-10 sm:mb-16" data-id="element-2587">
              {/* Glowing background effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-600/20 via-teal-500/30 to-emerald-600/20 blur-3xl" data-id="element-2588" />

              <div className="relative" data-id="element-2589">
                <h3 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-center mb-6 leading-tight" style={{
                fontFamily: 'Cinzel, serif'
              }} data-id="element-2590">
                  <span className="block bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-500 bg-clip-text text-transparent" style={{
                  textShadow: '0 0 40px rgba(16, 185, 129, 0.6)'
                }} data-id="element-2591">
                    The Precision Cell™ Method:
                  </span>
                  <span className="block mt-2 sm:mt-4 text-stone-100" style={{
                  textShadow: '0 0 30px rgba(16, 185, 129, 0.3)'
                }} data-id="element-2592">
                    The Secret Weapon for
                  </span>
                  <span className="block mt-2 bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent" style={{
                  textShadow: '0 0 40px rgba(20, 184, 166, 0.6)'
                }} data-id="element-2593">
                    Biological Transformation
                  </span>
                </h3>

                {/* Decorative underline */}
                <motion.div initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                duration: 1,
                delay: 0.5
              }} className="w-32 sm:w-64 h-1 bg-gradient-to-r from-transparent via-emerald-500 to-transparent mx-auto" data-id="element-2594" />
              </div>
            </div>

            {/* Content */}
            <div className="space-y-6 sm:space-y-8 text-lg md:text-xl leading-relaxed text-stone-300 max-w-4xl mx-auto" data-id="element-2595">
              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2596">
                Here's something most people don't know:
              </p>

              <p className="text-stone-100" data-id="element-2597">
                When private clients pay us $15,000 to $120,000 for
                transformation work...
              </p>

              <p className="text-stone-100 font-semibold" data-id="element-2598">
                They're not just "getting peptide protocols."
              </p>

              <div className="bg-gradient-to-br from-emerald-950/40 via-teal-950/30 to-black border-2 border-emerald-500/50 p-6 sm:p-8 my-6 sm:my-8 relative overflow-hidden" data-id="element-2599">
                {/* Subtle animated background particles */}
                <div className="absolute inset-0 opacity-20" data-id="element-2600">
                  {[...Array(6)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-emerald-400 rounded-full" style={{
                  left: `${20 + i * 15}%`,
                  top: `${30 + i % 3 * 20}%`
                }} animate={{
                  y: [-10, 10, -10],
                  opacity: [0.3, 1, 0.3]
                }} transition={{
                  duration: 3,
                  repeat: Infinity,
                  delay: i * 0.5,
                  ease: 'easeInOut'
                }} data-id="element-2601" />)}
                </div>

                <p className="text-lg sm:text-xl md:text-2xl text-stone-100 font-bold mb-4 relative z-10" data-id="element-2602">
                  They're getting access to a proprietary methodology that we
                  have developed over years of real-world application.
                </p>

                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center mt-6 relative z-10" data-id="element-2603">
                  <span className="bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent" style={{
                  textShadow: '0 0 30px rgba(16, 185, 129, 0.5)'
                }} data-id="element-2604">
                    It's called the Precision Cell™ method.
                  </span>
                </p>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2605">
                And it's one of the reasons we can create transformations that
                seem impossible to everyone else.
              </p>

              {/* "Here's what it helps you to do" Section */}
              <div className="mt-8 sm:mt-12 mb-6 sm:mb-8" data-id="element-2606">
                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-emerald-400 mb-6 sm:mb-8" data-id="element-2607">
                  Here's what it helps you to do:
                </p>

                {/* Benefits List - Visually Strong */}
                <div className="space-y-4 sm:space-y-6" data-id="element-2608">
                  {/* Benefit 1 */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.5
                }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-emerald-950/30 to-transparent border-l-4 border-emerald-500 rounded-r-lg" data-id="element-2609">
                    <span className="text-emerald-400 text-xl sm:text-2xl flex-shrink-0 font-bold" data-id="element-2610">
                      →
                    </span>
                    <p className="text-stone-100 text-base sm:text-lg" data-id="element-2611">
                      Look at a "hopeless" case and see{' '}
                      <span className="font-bold text-emerald-400" data-id="element-2612">
                        EXACTLY
                      </span>{' '}
                      what needs to be done{' '}
                      <span className="text-stone-400 italic" data-id="element-2613">
                        (while other practitioners are still guessing)
                      </span>
                    </p>
                  </motion.div>

                  {/* Benefit 2 */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.5,
                  delay: 0.1
                }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-teal-950/30 to-transparent border-l-4 border-teal-500 rounded-r-lg" data-id="element-2614">
                    <span className="text-teal-400 text-xl sm:text-2xl flex-shrink-0 font-bold" data-id="element-2615">
                      →
                    </span>
                    <p className="text-stone-100 text-base sm:text-lg" data-id="element-2616">
                      Design protocols that work when everything else has failed{' '}
                      <span className="text-stone-400 italic" data-id="element-2617">
                        (because you understand mechanisms at the molecular
                        level)
                      </span>
                    </p>
                  </motion.div>

                  {/* Benefit 3 */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.5,
                  delay: 0.2
                }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-emerald-950/30 to-transparent border-l-4 border-emerald-500 rounded-r-lg" data-id="element-2618">
                    <span className="text-emerald-400 text-xl sm:text-2xl flex-shrink-0 font-bold" data-id="element-2619">
                      →
                    </span>
                    <p className="text-stone-100 text-base sm:text-lg" data-id="element-2620">
                      Reverse conditions that mainstream medicine calls
                      "permanent"{' '}
                      <span className="text-stone-400 italic" data-id="element-2621">
                        (because you know which tissues respond to which
                        peptides and how to sequence them for maximum effect)
                      </span>
                    </p>
                  </motion.div>

                  {/* Benefit 4 */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.5,
                  delay: 0.3
                }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-teal-950/30 to-transparent border-l-4 border-teal-500 rounded-r-lg" data-id="element-2622">
                    <span className="text-teal-400 text-xl sm:text-2xl flex-shrink-0 font-bold" data-id="element-2623">
                      →
                    </span>
                    <p className="text-stone-100 text-base sm:text-lg" data-id="element-2624">
                      Optimize your biology (or your clients' biology) with the
                      kind of{' '}
                      <span className="font-bold text-teal-400" data-id="element-2625">precision</span>{' '}
                      that creates measurable, undeniable results
                    </p>
                  </motion.div>

                  {/* Benefit 5 */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.5,
                  delay: 0.4
                }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-emerald-950/30 to-transparent border-l-4 border-emerald-500 rounded-r-lg" data-id="element-2626">
                    <span className="text-emerald-400 text-xl sm:text-2xl flex-shrink-0 font-bold" data-id="element-2627">
                      →
                    </span>
                    <p className="text-stone-100 text-base sm:text-lg" data-id="element-2628">
                      Operate{' '}
                      <span className="font-bold text-emerald-400" data-id="element-2629">
                        10-20 years ahead
                      </span>{' '}
                      of mainstream medicine{' '}
                      <span className="text-stone-400 italic" data-id="element-2630">
                        (because you're not waiting for "official" validation)
                      </span>
                    </p>
                  </motion.div>
                </div>
              </div>

              {/* "This is the REAL value" Section */}
              <div className="bg-gradient-to-br from-teal-950/40 via-emerald-950/30 to-black border-2 border-teal-500/60 p-6 sm:p-8 md:p-10 my-8 sm:my-12 relative" data-id="element-2631">
                <div className="absolute top-0 left-0 w-8 sm:w-10 h-8 sm:h-10 border-l-2 border-t-2 border-teal-500" data-id="element-2632" />
                <div className="absolute top-0 right-0 w-8 sm:w-10 h-8 sm:h-10 border-r-2 border-t-2 border-emerald-500" data-id="element-2633" />
                <div className="absolute bottom-0 left-0 w-8 sm:w-10 h-8 sm:h-10 border-l-2 border-b-2 border-emerald-500" data-id="element-2634" />
                <div className="absolute bottom-0 right-0 w-8 sm:w-10 h-8 sm:h-10 border-r-2 border-b-2 border-teal-500" data-id="element-2635" />

                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-teal-400 mb-4 sm:mb-6" data-id="element-2636">
                  This is the REAL value.
                </p>

                <div className="space-y-3 sm:space-y-4 text-center" data-id="element-2637">
                  <p className="text-lg sm:text-xl text-stone-100" data-id="element-2638">
                    Not just knowing{' '}
                    <span className="font-bold text-emerald-400" data-id="element-2639">WHAT</span>{' '}
                    peptides to use.
                  </p>

                  <p className="text-xl sm:text-2xl font-bold text-stone-100" data-id="element-2640">
                    But understanding <span className="text-teal-400" data-id="element-2641">HOW</span>{' '}
                    to think about biology at the level Brenden and Ali do.
                  </p>
                </div>
              </div>

              {/* Final Value Proposition */}
              <div className="space-y-4 sm:space-y-6 mt-8 sm:mt-12" data-id="element-2642">
                <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-2643">
                  And when you join PSI PRO...
                </p>

                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent" data-id="element-2644">
                  You're getting the complete Precision Cell™ Pro methodology.
                </p>

                <div className="bg-gradient-to-br from-emerald-950/30 to-black border-l-4 border-emerald-500 p-6 sm:p-8 space-y-3 sm:space-y-4" data-id="element-2645">
                  <p className="text-stone-100 flex items-start gap-3 text-base sm:text-lg" data-id="element-2646">
                    <span className="text-emerald-400 flex-shrink-0" data-id="element-2647">✓</span>
                    <span data-id="element-2648">The same diagnostic frameworks.</span>
                  </p>
                  <p className="text-stone-100 flex items-start gap-3 text-base sm:text-lg" data-id="element-2649">
                    <span className="text-emerald-400 flex-shrink-0" data-id="element-2650">✓</span>
                    <span data-id="element-2651">The same protocol design principles.</span>
                  </p>
                  <p className="text-stone-100 flex items-start gap-3 text-base sm:text-lg" data-id="element-2652">
                    <span className="text-emerald-400 flex-shrink-0" data-id="element-2653">✓</span>
                    <span data-id="element-2654">The same optimization strategies.</span>
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-950/40 via-emerald-950/30 to-black border-2 border-emerald-500 p-6 sm:p-8 md:p-10 mt-6 sm:mt-8 relative" data-id="element-2655">
                  <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-emerald-500" data-id="element-2656" />
                  <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-teal-500" data-id="element-2657" />
                  <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-teal-500" data-id="element-2658" />
                  <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-emerald-500" data-id="element-2659" />

                  <p className="text-lg sm:text-xl md:text-2xl text-center text-stone-100 leading-relaxed" data-id="element-2660">
                    That private transformation clients paying upwards of{' '}
                    <span className="font-bold text-emerald-400 text-xl sm:text-2xl md:text-3xl" data-id="element-2661">
                      $30,000
                    </span>{' '}
                    get access to.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Divider */}

          {/* NEW SECTION: You Can't Fact-Check Everything */}
          <div className="space-y-8" data-id="element-2662"></div>

          {/* Divider */}

          {/* NEW SECTION: The Signal Is Getting Weaker */}
          <div className="space-y-8" data-id="element-2663"></div>
        </div>
      </motion.div>

      {/* NEW SECTION: Agitation - Are You Experiencing Results */}

      {/* New Section: Misinformation Crisis */}
      <motion.div ref={ref3} initial={{
      opacity: 0,
      y: 20
    }} animate={inView3 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-20 sm:mt-32" data-id="element-2664">
        {/* Decorative divider */}
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-2665">
          <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2666" />
          <AlertTriangle className="w-6 h-6 sm:w-8 sm:h-8 text-amber-500" data-id="element-2667" />
          <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-2668" />
        </div>

        {/* Main headline - Split into two parts */}
        <div className="mb-8 sm:mb-12 text-center" data-id="element-2669">
          <h2 className="text-xl sm:text-2xl md:text-4xl font-serif text-stone-100 mb-4 sm:mb-6 tracking-wide" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-2670">
            What Does This Look Like When You HAVEN'T Made These Paradigm
            Shifts?
          </h2>

          <h2 className="text-2xl sm:text-4xl md:text-6xl font-serif text-amber-500 leading-tight font-bold" style={{
          fontFamily: 'Cinzel, serif',
          textShadow: '0 0 40px rgba(217, 119, 6, 0.4)'
        }} data-id="element-2671">
            {' '}
            <span className="text-red-500 drop-shadow-lg" style={{
            textShadow: '0 0 30px rgba(220, 38, 38, 0.5)'
          }} data-id="element-2672">
              6 of the Most Common Lies Being Spread About Peptides
            </span>
          </h2>
        </div>

        {/* Sub-headline */}

        {/* Normal text */}
        <div className="space-y-4 sm:space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-2673">
          <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-2674">
            See if you've heard people say any of the following...
          </p>
        </div>
      </motion.div>

      {/* NEW SECTION: Classic Misinformation #1 - ENHANCED HEADER */}
      <motion.div ref={ref4} initial={{
      opacity: 0,
      y: 20
    }} animate={inView4 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-2675">
        {/* Decorative Divider */}
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-2676">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2677" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-2678" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2679" />
        </div>

        {/* DRAMATICALLY ENHANCED HEADLINE */}
        <div className="relative mb-8 sm:mb-12" data-id="element-2680">
          {/* Intense glow background */}
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-2xl animate-pulse-slow" data-id="element-2681" />

          {/* Main header container */}
          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-4 border-amber-600/60 p-6 sm:p-8 md:p-10 shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-2682">
            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2683">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2684" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2685" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-2686" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2687">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2688" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2689" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-2690" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2691">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2692" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2693" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-2694" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2695">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2696" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2697" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-2698" />
            </div>

            {/* Icon */}
            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-2699">
              <div className="relative" data-id="element-2700">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-2701" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-2702" />
              </div>
            </div>

            {/* Number badge */}
            <div className="text-center mb-4" data-id="element-2703">
              <span className="inline-block px-4 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-[0.2em] sm:tracking-[0.3em] uppercase text-sm sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-2704">
                Classic Misinformation Spread In The Peptide World #1
              </span>
            </div>

            {/* Main title */}
            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-2705">
              The "Peptides & Small Molecule Drugs Are the Same" Myth
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-2706">
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-2707" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-2708">
            <p data-id="element-2709">
              Have you ever heard of the compound{' '}
              <span className="text-stone-100 font-semibold" data-id="element-2710">SLU-PP-332</span>?
              Or perhaps{' '}
              <span className="text-stone-100 font-semibold" data-id="element-2711">MK-677</span>? How
              about Tesofensine, BAM15 or PEA?
            </p>

            <p className="font-medium text-amber-500/90 italic" data-id="element-2712">
              If you have, here's the question:
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-2713">
              Have you heard people call them peptides?
            </p>

            <p data-id="element-2714">
              I know of world renowned doctors and influencers with hundreds of
              thousands of followers that continually push this nonsense.
            </p>

            <p data-id="element-2715">I have to wonder if they do it intentionally.</p>

            <p data-id="element-2716">
              Because they will often position peptides and bioregulators as
              having "no side effects" (which can be true when they're properly
              classified, for example Khavinson's bioregulators seem to be
              largely side-effect free even up to extreme dosages).
            </p>

            <div className="flex gap-4 items-start bg-red-950/20 p-4 sm:p-6 border border-red-900/30 rounded-sm my-6 sm:my-8" data-id="element-2717">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-2718" />
              <div data-id="element-2719">
                <p className="text-stone-100 font-bold text-base sm:text-lg mb-2" data-id="element-2720">
                  But those compounds are NOT peptides...
                </p>
                <p className="text-red-200/80 text-sm sm:text-base" data-id="element-2721">
                  ...and they can have{' '}
                  <span className="text-red-400 font-bold uppercase tracking-wide" data-id="element-2722">
                    EXTREME side-effects
                  </span>{' '}
                  when used incorrectly.
                </p>
              </div>
            </div>

            <p className="text-sm sm:text-base text-stone-400 italic pl-4 sm:pl-6 border-l border-stone-700" data-id="element-2723">
              (There is also very minimal human safety data on many of them.
              With many of the dosages being recommended, when properly
              converted for humans, simply being impossible to even be
              effective.)
            </p>

            <p data-id="element-2724">
              But they pass them off as if they're all peptides, and they make
              the compounds look better than they are.
            </p>

            <p className="text-stone-100 font-medium" data-id="element-2725">
              Which results in people paying premium prices for inferior
              products, often implementing protocols that can't possibly work at
              the suggested dosages, putting their organs at risk of being
              damaged, and questioning why they aren't getting results.
            </p>
          </div>
        </div>
      </motion.div>

      {/* Classic Misinformation #2 - ENHANCED HEADER */}
      <motion.div ref={ref5} initial={{
      opacity: 0,
      y: 20
    }} animate={inView5 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-2726">
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-2727">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2728" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-2729" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2730" />
        </div>

        <div className="relative mb-8 sm:mb-12" data-id="element-2731">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-2xl animate-pulse-slow" data-id="element-2732" />

          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-4 border-amber-600/60 p-6 sm:p-8 md:p-10 shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-2733">
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2734">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2735" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2736" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-2737" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2738">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2739" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2740" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-2741" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2742">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2743" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2744" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-2745" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2746">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2747" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2748" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-2749" />
            </div>

            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-2750">
              <div className="relative" data-id="element-2751">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-2752" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-2753" />
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-2754">
              <span className="inline-block px-4 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-[0.2em] sm:tracking-[0.3em] uppercase text-sm sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-2755">
                Classic Misinformation Spread In The Peptide World #2
              </span>
            </div>

            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-2756">
              The "Peptides Don't Work Orally" Fallacy
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-2757">
          <div className="absolute top-0 left-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 -translate-x-1/2" data-id="element-2758" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-2759">
            <p data-id="element-2760">
              Here's how you instantly identify someone who doesn't actually
              understand peptides:
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-2761">
              They say "peptides don't work orally."
            </p>

            <p data-id="element-2762">
              There are multiple doctors out there spreading this idea with
              confidence.
            </p>

            <div className="flex gap-4 items-start bg-red-950/20 p-4 sm:p-6 border border-red-900/30 rounded-sm my-6 sm:my-8" data-id="element-2763">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-2764" />
              <div data-id="element-2765">
                <p className="text-stone-100 font-bold text-base sm:text-lg mb-2" data-id="element-2766">
                  But it's COMPLETELY wrong.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start bg-green-950/20 p-4 sm:p-6 border border-green-900/30 rounded-sm my-6 sm:my-8" data-id="element-2767">
              <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-2768" />
              <div data-id="element-2769">
                <p className="text-stone-100 font-bold text-base sm:text-lg mb-2" data-id="element-2770">
                  The truth:
                </p>
                <p className="text-green-200/80 text-sm sm:text-base" data-id="element-2771">
                  Many peptides{' '}
                  <span className="text-green-400 font-bold uppercase tracking-wide" data-id="element-2772">
                    DO work orally
                  </span>
                  . But many peptides also do NOT work orally. It's not black &
                  white.
                </p>
              </div>
            </div>

            <p data-id="element-2773">
              The key is understanding the specific characteristics that
              determine oral bioavailability, and ultimately knowing which ones
              will work compared to which ones won't.
            </p>

            <p data-id="element-2774">
              When someone makes blanket statements about oral peptides, they're
              showing you they don't understand the biological mechanisms behind
              how they work.
            </p>

            <p className="text-stone-100 font-medium italic border-l border-stone-700 pl-4 sm:pl-6 text-sm sm:text-base" data-id="element-2775">
              They're regurgitating oversimplified "rules" instead of operating
              from mechanistic understanding.
            </p>
          </div>
        </div>
      </motion.div>

      {/* Classic Misinformation #3 - ENHANCED HEADER */}
      <motion.div ref={ref6} initial={{
      opacity: 0,
      y: 20
    }} animate={inView6 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-2776">
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-2777">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2778" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-2779" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2780" />
        </div>

        <div className="relative mb-8 sm:mb-12" data-id="element-2781">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-2xl animate-pulse-slow" data-id="element-2782" />

          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-4 border-amber-600/60 p-6 sm:p-8 md:p-10 shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-2783">
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2784">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2785" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2786" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-2787" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2788">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2789" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2790" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-2791" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2792">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2793" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2794" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-2795" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2796">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2797" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2798" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-2799" />
            </div>

            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-2800">
              <div className="relative" data-id="element-2801">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-2802" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-2803" />
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-2804">
              <span className="inline-block px-4 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-[0.2em] sm:tracking-[0.3em] uppercase text-sm sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-2805">
                Classic Misinformation Spread In The Peptide World #3
              </span>
            </div>

            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-2806">
              The Timing Protocol That's Destroying Your Absorption
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-2807">
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-2808" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-2809">
            <p data-id="element-2810">
              Even the official manufacturer's recommendations for when to take
              peptide capsules are actually harmful for absorption.
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-2811">
              The standard advice of "take with food" is NOT based on
              bioavailability or effectiveness.
            </p>

            <div className="flex gap-4 items-start bg-amber-950/20 p-4 sm:p-6 border border-amber-900/30 rounded-sm my-6 sm:my-8" data-id="element-2812">
              <Clock className="w-6 h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-2813" />
              <div data-id="element-2814">
                <p className="text-stone-100 font-bold text-base sm:text-lg mb-2" data-id="element-2815">
                  The reality:
                </p>
                <p className="text-amber-200/80 text-sm sm:text-base" data-id="element-2816">
                  Taking oral peptides with food (particularly protein) is going
                  to{' '}
                  <span className="text-red-400 font-bold uppercase tracking-wide" data-id="element-2817">
                    reduce its effectiveness
                  </span>
                  .
                </p>
              </div>
            </div>

            <p data-id="element-2818">
              In fact, Brenden Henry specifically recommends taking orally
              bioavailable peptides on an{' '}
              <span className="text-stone-100 font-bold uppercase" data-id="element-2819">
                EMPTY STOMACH
              </span>{' '}
              (the exact opposite of most recommendations) for maximum
              absorption.
            </p>

            <p className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 text-sm sm:text-base" data-id="element-2820">
              <span className="text-amber-500 font-bold" data-id="element-2821">Why?</span> Because
              when proteins are in your stomach, they will compete with peptides
              for absorption via LAT and PEPT transporters.
            </p>

            <p data-id="element-2822">
              The official dosing information on many boxes is simply not
              optimal.
            </p>

            <p data-id="element-2823">
              And for the "experts" who DO know you can dose peptides orally,
              they're just parroting advice that's literally reducing the
              effectiveness of your protocols.
            </p>

            <p className="text-stone-100 font-medium italic border-l border-stone-700 pl-4 sm:pl-6 text-sm sm:text-base" data-id="element-2824">
              But you have no way of knowing this unless you've studied the
              original absorption kinetics research.
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold" data-id="element-2825">
              Brenden has. You haven't. Neither has anyone else teaching
              peptides online.
            </p>
          </div>
        </div>
      </motion.div>

      {/* Classic Misinformation #4 - ENHANCED HEADER */}
      <motion.div ref={ref7} initial={{
      opacity: 0,
      y: 20
    }} animate={inView7 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-2826">
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-2827">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2828" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-2829" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2830" />
        </div>

        <div className="relative mb-8 sm:mb-12" data-id="element-2831">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-2xl animate-pulse-slow" data-id="element-2832" />

          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-4 border-amber-600/60 p-6 sm:p-8 md:p-10 shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-2833">
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2834">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2835" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2836" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-2837" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2838">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2839" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2840" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-2841" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2842">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2843" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2844" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-2845" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2846">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2847" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2848" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-2849" />
            </div>

            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-2850">
              <div className="relative" data-id="element-2851">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-2852" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-2853" />
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-2854">
              <span className="inline-block px-4 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-[0.2em] sm:tracking-[0.3em] uppercase text-sm sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-2855">
                Classic Misinformation Spread In The Peptide World #4
              </span>
            </div>

            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-2856">
              The False "BPC-157 Is the Best Healing Peptide" Narrative
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-2857">
          <div className="absolute top-0 left-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 -translate-x-1/2" data-id="element-2858" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-2859">
            <p data-id="element-2860">
              Here's something that will shock most people in the peptide
              community:
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-2861">
              We do NOT generally recommend BPC-157 for healing.
            </p>

            <p data-id="element-2862">Not because it doesn't work.</p>

            <p data-id="element-2863">
              But because there's a{' '}
              <span className="text-amber-500 font-bold" data-id="element-2864">
                vastly superior, yet basically unknown peptide
              </span>{' '}
              we recommend instead for most healing protocols.
            </p>

            <div className="bg-stone-950/50 p-4 sm:p-6 border border-stone-800 rounded-sm my-6 sm:my-8" data-id="element-2865">
              <p className="text-stone-100 font-bold mb-4 flex items-center gap-2 text-base sm:text-lg" data-id="element-2866">
                <CheckCircle className="w-5 h-5 text-green-500" data-id="element-2867" />
                This superior peptide has:
              </p>
              <ul className="space-y-3 text-sm sm:text-base" data-id="element-2868">
                <li className="flex items-start gap-3" data-id="element-2869">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-2870" />
                  <span data-id="element-2871">Better tissue regeneration properties</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-2872">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-2873" />
                  <span data-id="element-2874">Fewer side effect risks</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-2875">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-2876" />
                  <span data-id="element-2877">More comprehensive healing mechanisms</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-2878">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-2879" />
                  <span data-id="element-2880">FAR MORE research and safety data in humans</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-2881">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-2882" />
                  <span data-id="element-2883">
                    Can be taken even in extremely high dosages with basically
                    NO negative effects seen
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-2884">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-2885" />
                  <span data-id="element-2886">
                    The ability to enhance your biological function at the DNA
                    level
                  </span>
                </li>
              </ul>
            </div>

            <p data-id="element-2887">
              But almost nobody knows about it because they're stuck in the
              BPC-157 echo chamber.
            </p>

            <p data-id="element-2888">
              Influencers teach BPC-157 because it's what everyone else teaches.
            </p>

            <p data-id="element-2889">
              Practitioners recommend BPC-157 because it's what they learned
              from those influencers.
            </p>

            <div className="flex gap-4 items-start bg-red-950/20 p-4 sm:p-6 border border-red-900/30 rounded-sm my-6 sm:my-8" data-id="element-2890">
              <ShieldAlert className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-2891" />
              <div data-id="element-2892">
                <p className="text-red-200/80 text-sm sm:text-base" data-id="element-2893">
                  Meanwhile, you're using a second-tier healing peptide with the
                  potential for some{' '}
                  <span className="text-red-400 font-bold uppercase tracking-wide" data-id="element-2894">
                    harrowing side-effects
                  </span>{' '}
                  (like anhedonia) when a superior option exists.
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Classic Misinformation #5 - ENHANCED HEADER */}
      <motion.div ref={ref8} initial={{
      opacity: 0,
      y: 20
    }} animate={inView8 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-2895">
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-2896">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2897" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-2898" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2899" />
        </div>

        <div className="relative mb-8 sm:mb-12" data-id="element-2900">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-2xl animate-pulse-slow" data-id="element-2901" />

          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-4 border-amber-600/60 p-6 sm:p-8 md:p-10 shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-2902">
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2903">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2904" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2905" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-2906" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2907">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2908" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2909" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-2910" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2911">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2912" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2913" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-2914" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2915">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2916" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2917" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-2918" />
            </div>

            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-2919">
              <div className="relative" data-id="element-2920">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-2921" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-2922" />
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-2923">
              <span className="inline-block px-4 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-[0.2em] sm:tracking-[0.3em] uppercase text-sm sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-2924">
                Classic Misinformation Spread In The Peptide World #5
              </span>
            </div>

            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-2925">
              The Growth Hormone Releasing Peptide Paradox
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-2926">
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-2927" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-2928">
            <p data-id="element-2929">
              This is the one that proves beyond doubt how surface-level most
              "expert" knowledge is:
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-2930">
              Growth Hormone Releasing Peptides like sermorelin, ipamorelin and
              CJC-1295 might be the WORST choice if you want to increase growth
              hormone levels.
            </p>

            <p className="font-bold text-amber-500 italic" data-id="element-2931">Read that again.</p>

            <p data-id="element-2932">
              The peptides specifically marketed for increasing growth hormone
              might be the worst option for that goal.
            </p>

            <p data-id="element-2933">
              <span className="text-stone-100 font-bold" data-id="element-2934">Why?</span>
            </p>

            <div className="flex gap-4 items-start bg-red-950/20 p-4 sm:p-6 border border-red-900/30 rounded-sm my-6 sm:my-8" data-id="element-2935">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-2936" />
              <div data-id="element-2937">
                <p className="text-red-200/80 text-sm sm:text-base" data-id="element-2938">
                  Because every single one of these options brings a whole host
                  of potential risks, side-effects and extra responsibilities to
                  make sure you do it properly...
                </p>
                <p className="text-stone-100 font-bold mt-2 text-base sm:text-lg" data-id="element-2939">
                  While resulting in WORSE effects than the superior option.
                </p>
              </div>
            </div>

            <p data-id="element-2940">
              Yet these are ultimately the most well-known options in the
              peptide world when it comes to increasing growth hormone levels.
            </p>

            <p className="text-stone-100 font-medium italic border-l border-stone-700 pl-4 sm:pl-6 text-sm sm:text-base" data-id="element-2941">
              Unless you understand these mechanisms at the molecular level,
              you're implementing protocols that sound right but deliver
              suboptimal results.
            </p>
          </div>
        </div>
      </motion.div>

      {/* Classic Misinformation #6 - ENHANCED HEADER */}
      <motion.div ref={ref9} initial={{
      opacity: 0,
      y: 20
    }} animate={inView9 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-2942">
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-2943">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2944" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-2945" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-2946" />
        </div>

        <div className="relative mb-8 sm:mb-12" data-id="element-2947">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-2xl animate-pulse-slow" data-id="element-2948" />

          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-4 border-amber-600/60 p-6 sm:p-8 md:p-10 shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-2949">
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2950">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2951" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2952" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-2953" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2954">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2955" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-2956" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-2957" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2958">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-2959" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2960" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-2961" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-2962">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-2963" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-2964" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-2965" />
            </div>

            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-2966">
              <div className="relative" data-id="element-2967">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-2968" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-2969" />
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-2970">
              <span className="inline-block px-4 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-[0.2em] sm:tracking-[0.3em] uppercase text-sm sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-2971">
                Classic Misinformation Spread In The Peptide World #6
              </span>
            </div>

            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-2972">
              The Bioregulator Blind Spot: Almost Nobody Knows They Exist
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-2973">
          <div className="absolute top-0 left-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 -translate-x-1/2" data-id="element-2974" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-2975">
            <p data-id="element-2976">
              This is the most shocking oversight in the entire peptide
              ecosystem:
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-2977">
              Most people in the peptide world have never even heard of
              Khavinson's bioregulator peptides.
            </p>

            <p data-id="element-2978">
              They talk endlessly about BPC-157, TB-500, CJC-1295, ipamorelin,
              semaglutide... yet remain completely oblivious to the category of
              peptides that are some of the most powerful, safest, and
              biologically transformative compounds humans have ever discovered.
            </p>

            <div className="bg-stone-950/50 p-4 sm:p-6 border border-stone-800 rounded-sm my-6 sm:my-8" data-id="element-2979">
              <div className="flex items-center gap-3 mb-4" data-id="element-2980">
                <Dna className="w-6 h-6 text-amber-500" data-id="element-2981" />
                <p className="text-stone-100 font-bold text-base sm:text-lg" data-id="element-2982">
                  Bioregulators are not "just another type of peptide."
                </p>
              </div>
              <p className="text-stone-300 pl-9 text-sm sm:text-base" data-id="element-2983">
                They operate differently. They target the genome itself. They
                influence tissue at the level of DNA transcription. They don't
                stimulate—they normalize. They don't push the body—they instruct
                it. They are an entirely different class of biological
                intelligence.
              </p>
            </div>

            <p data-id="element-2984">And yet...</p>

            <p data-id="element-2985">The peptide mainstream has absolutely no idea they exist.</p>

            <p data-id="element-2986">
              Even the so-called experts (educators, influencers, doctors with
              massive followings) are teaching an incomplete universe of
              peptides. Their map is missing the most valuable territory.
            </p>

            <p className="text-stone-100 font-bold mt-8" data-id="element-2987">But it goes deeper:</p>

            <p data-id="element-2988">
              Among the microscopic percentage of practitioners who do know
              about bioregulators, almost every single one of them only
              understands Version 1 bioregulator products.
            </p>

            <p className="text-amber-500 font-medium italic" data-id="element-2989">
              The lowest-tier, least evolved, bare-minimum formulations.
            </p>

            <div className="space-y-4 my-6 sm:my-8 pl-4 border-l-2 border-stone-700 text-sm sm:text-base" data-id="element-2990">
              <div data-id="element-2991">
                <p className="text-stone-100 font-bold" data-id="element-2992">
                  Version 1 = The bare minimum required to work
                </p>
                <p className="text-stone-400 text-xs sm:text-sm" data-id="element-2993">
                  (This is what everyone talks about. It's entry-level.)
                </p>
              </div>

              <div data-id="element-2994">
                <p className="text-stone-100 font-bold" data-id="element-2995">
                  Version 2 = A dramatically more potent biological signal
                </p>
                <p className="text-stone-400 text-xs sm:text-sm" data-id="element-2996">
                  (Rare, unknown, and exponentially more effective.)
                </p>
              </div>

              <div data-id="element-2997">
                <p className="text-stone-100 font-bold" data-id="element-2998">
                  Version 3 = So powerful they must be used with extreme caution
                </p>
                <p className="text-stone-400 text-xs sm:text-sm" data-id="element-2999">
                  (Nearly nobody has access, understanding, or safe dosing
                  knowledge.)
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start bg-amber-950/30 p-4 sm:p-6 border border-amber-600/50 rounded-sm my-6 sm:my-8" data-id="element-3000">
              <Zap className="w-6 h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-3001" />
              <div data-id="element-3002">
                <p className="text-stone-100 font-bold text-base sm:text-lg leading-relaxed" data-id="element-3003">
                  Peptide Mastery 2.0 is the ONLY place where you will discover
                  about all three versions and how to apply them in-depth, at a
                  level beyond anything else in the world.
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* NEW SECTION: Classic Misinformation #7 */}
      <motion.div ref={ref10} initial={{
      opacity: 0,
      y: 20
    }} animate={inView10 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-20 sm:mt-32" data-id="element-3004">
        {/* Decorative Divider */}
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-3005">
          <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-3006" />
          <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-3007" />
          <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-3008" />
        </div>

        {/* Headline with "problem" in red */}
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center mb-8 sm:mb-12 leading-tight" style={{
        fontFamily: 'Cinzel, serif'
      }} data-id="element-3009">
          <span className="block text-amber-500 font-bold mb-3" style={{
          textShadow: '0 0 40px rgba(217, 119, 6, 0.5)'
        }} data-id="element-3010">
            The{' '}
            <span className="relative inline-block" data-id="element-3011">
              <span className="text-red-500" style={{
              textShadow: '0 0 50px rgba(239, 68, 68, 0.8), 0 0 80px rgba(220, 38, 38, 0.4)'
            }} data-id="element-3012">
                Problem
              </span>
              <span className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-red-500 to-transparent opacity-60 blur-sm" data-id="element-3013" />
            </span>{' '}
            With All This:
          </span>
        </h2>

        {/* Body content */}
        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-3014">
          <p className="text-stone-100 font-semibold text-lg sm:text-xl border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/20 to-transparent" data-id="element-3015">
            The information you're relying on — even from "qualified experts" —
            is incomplete, oversimplified, or flat-out wrong.
          </p>

          <p className="text-stone-100" data-id="element-3016">
            And this isn't just about missing optimal results.
          </p>

          <p className="font-bold text-stone-100" data-id="element-3017">
            This is about making mistakes that compound over months and years.
          </p>

          <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-red-600/50 text-base sm:text-lg" data-id="element-3018">
            <p data-id="element-3019">
              <span className="text-red-400 font-bold" data-id="element-3020">
                Mistakes that silently damage your biology
              </span>{' '}
              while you think you're optimizing it.
            </p>

            <p data-id="element-3021">
              <span className="text-red-400 font-bold" data-id="element-3022">
                Mistakes that waste thousands of dollars
              </span>{' '}
              on ineffective products and protocols.
            </p>

            <p data-id="element-3023">
              <span className="text-red-400 font-bold" data-id="element-3024">
                Mistakes that cost you the irreplaceable resource of time
              </span>{' '}
              as your biology continues to decay.
            </p>
          </div>

          <p className="text-xl sm:text-2xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-3025">
            Or worse...
          </p>

          <p className="text-red-400 font-bold" data-id="element-3026">
            Mistakes that damage the trust of the people who rely on YOU for
            guidance.
          </p>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 my-8 sm:my-12" data-id="element-3027">
            <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-3028" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-3029" />
            <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-3030" />
          </div>

          {/* NEW SECTION: But You Can't Just Solve This With "Better Information" */}
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-6 sm:mb-8" style={{
          fontFamily: 'Cinzel, serif',
          textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
        }} data-id="element-3031">
            But You Can't Just Solve This With{' '}
            <span className="text-amber-500" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.5)'
          }} data-id="element-3032">
              "Better Information"
            </span>
          </h3>

          <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-3033">
            Here's what most people don't understand:
          </p>

          <p className="text-stone-100" data-id="element-3034">
            You can't solve this problem by just "finding better sources."
          </p>

          <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-3035">
            Because even the BEST sources out there are still operating with an
            incomplete paradigm.
          </p>

          <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-amber-600/30 text-base sm:text-lg" data-id="element-3036">
            <p data-id="element-3037">They're teaching you a FRACTION of what's possible.</p>
            <p data-id="element-3038">They're giving you a MAP that's missing half the territory.</p>
          </div>

          <p className="text-stone-100" data-id="element-3039">
            And no amount of "doing your own research" is going to fix that...
          </p>

          <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-3040">
            Unless you're willing to:
          </p>

          <div className="space-y-3 pl-4 sm:pl-6 border-l-2 border-stone-700 text-base sm:text-lg" data-id="element-3041">
            <p className="flex items-start gap-3" data-id="element-3042">
              <span className="text-amber-500 flex-shrink-0" data-id="element-3043">→</span>
              <span data-id="element-3044">Learn Russian</span>
            </p>
            <p className="flex items-start gap-3" data-id="element-3045">
              <span className="text-amber-500 flex-shrink-0" data-id="element-3046">→</span>
              <span data-id="element-3047">
                Track down obscure military and academic journals from the
                Soviet era
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-3048">
              <span className="text-amber-500 flex-shrink-0" data-id="element-3049">→</span>
              <span data-id="element-3050">
                Translate hundreds of studies that have never been brought to
                the West
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-3051">
              <span className="text-amber-500 flex-shrink-0" data-id="element-3052">→</span>
              <span data-id="element-3053">
                Spend years understanding peptide mechanisms at the molecular
                level
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-3054">
              <span className="text-amber-500 flex-shrink-0" data-id="element-3055">→</span>
              <span data-id="element-3056">
                Work with enough real human cases to know what actually works
                vs. what just sounds good in theory
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-3057">
              <span className="text-amber-500 flex-shrink-0" data-id="element-3058">→</span>
              <span data-id="element-3059">
                Develop your own diagnostic frameworks for identifying root
                causes
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-3060">
              <span className="text-amber-500 flex-shrink-0" data-id="element-3061">→</span>
              <span data-id="element-3062">
                Create your own protocol design methodology based on synergistic
                effects
              </span>
            </p>
          </div>

          <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-3063">
            In other words...
          </p>

          <p className="text-xl sm:text-2xl font-bold text-amber-500" data-id="element-3064">
            Unless you're willing to do what Brenden Henry has done.
          </p>

          <div className="space-y-3 pl-4 sm:pl-6 border-l-2 border-amber-600/30 text-base sm:text-lg" data-id="element-3065">
            <p data-id="element-3066">Which took him years of effort.</p>
            <p data-id="element-3067">And thousands of hours of obsessive research.</p>
            <p data-id="element-3068">And real-world application with over 1,500 participants.</p>
            <p data-id="element-3069">
              And private transformation work with clients paying $15K−$120K.
            </p>
          </div>

          <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-3070">
            So here's the reality:
          </p>

          <p className="text-stone-100" data-id="element-3071">You have two options.</p>

          <div className="bg-gradient-to-br from-stone-950/60 to-black border-2 border-stone-700 p-6 sm:p-8 my-6 sm:my-8" data-id="element-3072">
            <p className="text-lg sm:text-xl font-bold text-stone-100 mb-4" data-id="element-3073">
              Option 1:
            </p>
            <p className="text-stone-300 text-base sm:text-lg" data-id="element-3074">
              Spend the next 10+ years trying to figure this out on your own.
            </p>
            <p className="text-stone-400 text-sm mt-2 italic" data-id="element-3075">
              (And hope you don't make too many costly mistakes along the way.)
            </p>
          </div>

          <div className="bg-gradient-to-br from-amber-950/30 to-black border-2 border-amber-600/50 p-6 sm:p-8 my-6 sm:my-8" data-id="element-3076">
            <p className="text-lg sm:text-xl font-bold text-amber-400 mb-4" data-id="element-3077">
              Option 2:
            </p>
            <p className="text-stone-100 text-base sm:text-lg" data-id="element-3078">
              Get direct access to the people who've already done the work.
            </p>
            <p className="text-stone-100 text-base sm:text-lg" data-id="element-3079">
              Who've already made the paradigm shift.
            </p>
            <p className="text-stone-100 text-base sm:text-lg" data-id="element-3080">
              Who already KNOW what's possible.
            </p>
            <p className="text-stone-100 text-base sm:text-lg" data-id="element-3081">
              And who are willing to share it with you.
            </p>
          </div>

          <div className="bg-gradient-to-br from-amber-950/30 to-black border-2 border-amber-600 p-6 sm:p-8 md:p-10 mt-6 sm:mt-8 relative" data-id="element-3082">
            <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-amber-600" data-id="element-3083" />
            <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-amber-600" data-id="element-3084" />
            <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-amber-600" data-id="element-3085" />
            <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-amber-600" data-id="element-3086" />

            <p className="text-xl sm:text-2xl md:text-3xl text-center font-bold text-amber-500 leading-relaxed" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
          }} data-id="element-3087">
              That's what PSI PRO — The Private Research Order is.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}